import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import DefaultButton from '../../global/default-button/default-button';
import { RecurringZoomMeetingsFormVM } from './recurring-zoom-meetings-form.viewmodel';
import { MultiSelectButton } from '../../global/multi-select/multi-select-button';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import { GROUPS_TEXT, REMOVE_TEXT, addText, cancelText } from '../../../constants/common-labels.constants';
import { IZoomGroupDTO } from '../../../api/zoom.dao';
import { ADD_GROUPS_TEXT } from '../account-admin.text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';

interface IRecurringZoomMeetingsFormPresentationProps {
    vm: RecurringZoomMeetingsFormVM;
}

const RecurringZoomMeetingsFormPresentation = observer((props: IRecurringZoomMeetingsFormPresentationProps) => {
    const { vm } = props;
    const { zoomGroups, settingsEntity } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                    <div className='oe-form'>
                        <div className='oe-form__body'>
                            <div className='m-top-10px m-bottom-0px flex center'>
                                <OEToggle
                                    isSelected={settingsEntity.enabled}
                                    onClick={vm.toggleRecurringZoomMeetingsEnabled}
                                    dataTestId='toggle-third-party-registration'
                                />
                                <Text
                                    message='Recurring Zoom Meetings are {suffix}'
                                    id='oe.accountAdmin.recurringZoomMeetingsStatus'
                                    description='Label text'
                                    values={{
                                        suffix: settingsEntity.suffix
                                    }}
                                    className='line-height-25px'
                                />
                            </div>
                            {settingsEntity.enabled &&
                                <div className='m-top-10px m-bottom-0px'>
                                    <div className='event_form__items-section'>
                                        <div className='event_form__items-section__title'>
                                            <FormattedMessage {...GROUPS_TEXT} />
                                        </div>
                                        <div className='event_form__items-section__selected-items'>
                                            {(settingsEntity.additionalData as IZoomGroupDTO[])
                                                .slice()
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(({ name, zoomGroupId }) => (
                                                    <div
                                                        key={zoomGroupId}
                                                        className='event_form__items-section__item-wrapper'
                                                    >
                                                        <Text
                                                            className='event_form__items-section__item-label'
                                                            message={name}
                                                            withEllipsis
                                                        />
                                                        <DefaultButton
                                                            text={<FormattedMessage {...REMOVE_TEXT} />}
                                                            modifier='remove'
                                                            onClick={() => vm.removeZoomGroup(zoomGroupId)}
                                                            className='event_form__items-section__remove-item-button'
                                                        />
                                                    </div>
                                                ))}
                                        </div>
                                        <MultiSelectButton
                                            className='event_form__items-section__add-button'
                                            items={zoomGroups}
                                            disabled={settingsEntity.additionalData}
                                            value={settingsEntity.additionalData}
                                            keyProperty='zoomGroupId'
                                            nameProperty='name'
                                            text={
                                                <FormattedMessage
                                                    {...ADD_GROUPS_TEXT}
                                                    values={{
                                                        prefix: '+ '
                                                    }}
                                                />
                                            }
                                            applyButtonText={addText()}
                                            resetButtonText={cancelText()}
                                            onChange={vm.setAssignedZoomGroupList}
                                            withSearch={false}
                                        />
                                        {vm.isFormChecked && vm.getRecurringZoomMeetingsValidationError()
                                            && <div className='oe-form-field__error m-top-5px'>{vm.getRecurringZoomMeetingsValidationError()}</div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={vm.saving}
                />
            }
        />
    );
});

export { RecurringZoomMeetingsFormPresentation };
